import md5 from 'md5';

import VkontakteApi from './VkontakteApi';
import FacebookApi from './FacebookApi';

/* eslint-disable class-methods-use-this */
class Unlockshare {
  constructor() {
    this.okAppId = '1107384576';
    this.okAppKey = '0477D071CA658463FB039A6C';
    this.okCallbackFired = false;
    this.okListenerAttached = false;
  }

  /**
   * Share in Facebook
   * @param callback
   * @param data
   * @param data.url - url for share
   */
  fb(callback, data = {}) {
    FacebookApi.get()
      .then((FB) => {
        FB.ui({
          method: 'share',
          href: data.url,
        }, (response) => {
          callback(!!response);
        });
      })
      .catch(() => {
        callback(false);
      });
  }

  /**
   * Share in Vkontakte
   * @param callback
   * @param data
   * @param data.text - post text
   * @param data.url - url for share
   */
  vk(callback, data = {}) {
    VkontakteApi.get()
      .then((VK) => {
        // https://vk.com/dev/wall.post
        const postParams = {
          message: data.text || '',
          attachments: data.url || document.location.href,
        };

        function wallPost() {
          VK.Api.call('wall.post', postParams, (r) => {
            if (r.error) {
              callback(false);
              return;
            }

            if (r.response.post_id) {
              callback(true);
              return;
            }

            callback(false);
          });
        }

        VK.Auth.getLoginStatus((r) => {
          if (r.session) {
            wallPost();
            return;
          }

          VK.Auth.login((r) => {
            if (r.session) {
              wallPost();
              return;
            }

            callback(false);
          });
        });
      })
      .catch(() => {
        callback(false);
      });
  }

  /**
   * Share in OK
   * @param callback
   * @param data
   * @param data.url - url for share
   */
  ok(callback, data = {}) {
    const url = data.url || window.location.href;

    this.okCallbackFired = false;
    this.okListenerAttached = false;

    const attachment = {
      media: [
        {
          type: 'link',
          url,
        },
      ],
    };

    let attachmentString = JSON.stringify(attachment);

    const sign = md5(`st.attachment=${attachmentString + this.okAppKey}`);

    attachmentString = encodeURIComponent(attachmentString);

    const shareUrl = `https://connect.ok.ru/dk?st.cmd=WidgetMediatopicPost&st.app=${this.okAppId}&st.attachment=${attachmentString}&st.signature=${sign}&st.popup=on&st.silent=on&st.utext=off`;

    const popup = this.openWindow(shareUrl);

    function listener(event) {
      if (event.origin !== 'https://connect.ok.ru') return;
      if (event.data === 'loaded') return; // popup open event
      if (!event.data) return;

      let data;
      let postId;

      try {
        data = JSON.parse(event.data);
        postId = parseInt(data.id, 10);
        if (postId) {
          window.removeEventListener('message', listener);
          this.okListenerAttached = false;
        }
      } catch (e) {
        // do nothing;
      } finally {
        callback(!!postId);
        this.okCallbackFired = true;
      }
    }

    const checkPopupClose = setInterval(() => {
      if (popup.closed) {
        clearInterval(checkPopupClose);

        if (!this.okCallbackFired) {
          callback(false);
        }
        window.removeEventListener('message', listener);
      }
    }, 1000);

    if (!this.okListenerAttached) {
      window.addEventListener('message', listener);
      this.okListenerAttached = true;
    }
  }

  /**
   * Share in TW
   * @param callback
   * @param data
   * @param data.url - url for share
   * @param data.text - tweet text
   * TODO: more secure implementation
   */
  tw(callback, data = {}) {
    // https://twitter.com/intent/tweet
    const url = data.url || window.location.href;
    const text = data.text || '';
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    const popup = this.openWindow(shareUrl);
    const checkPopupClose = setInterval(() => {
      if (popup.closed) {
        clearInterval(checkPopupClose);
        callback(true);
      }
    }, 1000);
  }

  openWindow(url) {
    return window.open(url, '', `width=640,height=480,left=${(window.screen.width - 640) / 2},top=${(window.screen.height - 480) / 2},location=no,toolbar=no,menubar=no,scrollbars=1`);
  }
}

export default new Unlockshare();
